import { ChannelAccount, ProvisionalPost } from "../../../types";

export const getBodyCharacterLimit = (
  bPid: number,
  pocs: ProvisionalPost["post_on_channels_attributes"],
  hChannelAccounts: Record<number, ChannelAccount>,
): number | undefined => {
  const limits = pocs
    .filter((poc) => poc.body_provisional_id === bPid)
    .map((poc) => hChannelAccounts[poc.channel_account_id]?.channel_constraints?.character_limit)
    .filter((l): l is number => typeof l === "number");
  return limits.length > 0 ? Math.min(...limits) : undefined;
};
